import { httpCreate } from './http';
const http = httpCreate('/srv/marketing-sms-send-record');

export const marketingSmsSendRecord = {
	getList(taskId, params) {
		return http.get(`/list/${taskId}`, { params });
	},
};
